/**
 * Classe utilitaire pour les dates
 */

export default class DateHelper {

    /**
     * Retourne la liste des noms des mois
     * @param locale
     * @return array
     */
    static getMonths(locale) {
        const currentYear = (new Date()).getFullYear()
        const indexes = new Array(12).keys();

        return [ ...indexes ]
            .map((monthIndex) => new Date(currentYear, monthIndex)
                .toLocaleString(locale, { month: 'long' })
            )
        ;
    };

    /**
     * Retourne un tableau de d'années
     * @param int relativeNegativeCurrentYear (-10)
     * @param int relativePositiveCurrentYear (10)
     * @return array
     */
    static getYearsRange(relativeNegativeCurrentYear, relativePositiveCurrentYear) {
        const currentYear = (new Date()).getFullYear();

        const startYear = currentYear + relativeNegativeCurrentYear;
        const number = relativePositiveCurrentYear - relativeNegativeCurrentYear;

        const indexes = new Array(number).keys();

        return [ ...indexes ]
            .map((index) => startYear + index)
            ;
    };

    /**
     * Formate la date en paramètre en fonction de la locale
     * @param string stringDate
     * @param string locale
     * @param object options Options pour l'objet Intl.DateTimeFormat
     * @return string
     */
    static formatted(stringDate, locale, options = {}) {
        if(! stringDate) {
            return '';
        }
        const date = new Date(stringDate);
        return new Intl.DateTimeFormat(locale, options).format(date);
    };

    /**
     * Retour la date de début du jour de la date en paramètre
     * @param string stringDate Chaine de caractère de la date acceptée par l'objet Date
     * @return Date
     */
    static getStartOfDay(stringDate) {
        const start = (new Date(stringDate))
        start.setHours(0, 0, 0, 0);
        return start;
    };

    /**
     * Retour la date de fin du jour de la date en paramètre
     * @param string stringDate Chaine de caractère de la date acceptée par l'objet Date
     * @return Date
     */
    static getEndOfDay(stringDate) {
        const end = (new Date(stringDate))
        end.setHours(23, 59, 59, 999);
        return end;
    };

    /**
     * Retourne la date formatée en chaine de caractères pour l'affichage au format YYYY-mm-ddTHH:mm
     * @param Date date
     * @param bool withTime Vrai s'il faut retourner l'heure
     * @return string
     */
    static getDateTimeStringForInputDate(date, withTime) {

        const hours = date.getHours();
        const minutes = date.getMinutes();

        const dateString = DateHelper.getDateTimeStringFromDate(date);

        if(! withTime) {
            return dateString;
        }

        const timeString = [
            (new String(hours)).padStart(2, '0'),
            (new String(minutes)).padStart(2, '0')
        ].join(':');

        return [
            dateString,
            timeString
        ].join('T');
    };

    /**
     * Retourne la date sous forme de chaine de caractères au format YYYY-mm-dd à partir d'un objet date
     * @param Date date
     * @return string
     */
    static getDateTimeStringFromDate(date) {
        const year = date.getFullYear();
        const yearString = (new String(year)).padStart(4, 0);
        const month = new String(date.getMonth() + 1);
        const stringMonth = month.padStart(2, '0');
        const day = new String(date.getDate());
        const stringDay = day.padStart(2, '0');

        return [
            yearString,
            stringMonth,
            stringDay
        ].join('-');
    }

    /**
     * Retourne la date sous forme de chaine de caractères au format YYYY-mm-dd
     * @param string stringDate Date sous forme de chaine de caractères acceptée par la classe native Date
     * @return string
     */
    static getDateTimeString(stringDate, withTime = false) {
        const date = new Date(stringDate);

        let newStringDate = DateHelper.getDateTimeStringFromDate(date);

        if(withTime) {
            const hours = new String(date.getHours());
            const stringHours = hours.padStart(2, '0');
            /***/
            const minutes = new String(date.getMinutes());
            const stringMinutes = minutes.padStart(2, '0');
            /***/
            const seconds = new String(date.getSeconds());
            const stringSeconds = seconds.padStart(2, '0');

            newStringDate += ' ' + [
                stringHours,
                stringMinutes,
                stringSeconds
            ].join(':');
        }

        return newStringDate;
    };

    /**
     * Retourne si la chaine en paramètre est une date valide
     * @param string stringDate
     * @return bool
     */
    static isValid(stringDate) {
        const unixTime = Date.parse(stringDate);
        return (! isNaN(unixTime));
    };

};
